import { render } from "./VacunaPersTabla01.vue?vue&type=template&id=546d4e5d&scoped=true"
import script from "./VacunaPersTabla01.vue?vue&type=script&lang=js"
export * from "./VacunaPersTabla01.vue?vue&type=script&lang=js"

import "./VacunaPersTabla01.vue?vue&type=style&index=0&id=546d4e5d&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-546d4e5d"]])

export default __exports__